<template>
  <div class="imgThumb">
    <img class="imgThumb--img" :src="img" :alt="alt">
  </div>
</template>

<script>
export default {
  name: 'ImgThumb',
  props: {
    alt: {
      type: String,
      default: 'Observatório Internacional de Capacidades Humanas, Desenvolvimento e Políticas Públicas'
    },
    img: {
      type: String,
      default: 'http://capacidadeshumanas.org/oichsitev3/wp-content/uploads/2018/10/default.png'
    }
  }
}
</script>

<style>

</style>
